let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a5Alm")).then(() => parcelRequire('cOjgE'));